<div class="container">
    <mat-icon [svgIcon]="icon"></mat-icon>
    <span>{{ data.message }}</span>
</div>

